export enum PlanType {
  PLAN_UNSET_TYPE = 'PLAN_UNSET_TYPE', // Do not use, needed because of proto3 limitations
  PLAN_MBB = 'PLAN_MBB',
  PLAN_HBB = 'PLAN_HBB',
}
